import { render, staticRenderFns } from "./SurfaceDamagesForm.vue?vue&type=template&id=6db349a0&scoped=true"
import script from "./SurfaceDamagesForm.vue?vue&type=script&lang=ts"
export * from "./SurfaceDamagesForm.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceDamagesForm.vue?vue&type=style&index=0&id=6db349a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db349a0",
  null
  
)

export default component.exports